import { AUTH_MESSAGE_NOT_AUTHORIZED } from '@/config/auth';
import { CONFIG_ROUTES } from '@/config/routes';
import { qx_ePrivilege_enum } from '@/graphql/types';
import { getRouteTreeProperty, getFirstAccessibleNavigationRouteName } from '@/router/utilities';
import { useNotifyStore } from '@/store/notify';
import { useAuthStore } from '@/store/auth';

const UserHasPrivileges: Middleware = async function(ctx) {
  const privileges = getRouteTreeProperty<qx_ePrivilege_enum[]>(ctx.to, 'privileges');
  if (!privileges?.length) {
    return;
  }

  const auth = useAuthStore();
  await auth.account.authenticate();

  if (!auth.user.hasPrivileges(privileges)) {

    // `APP_HOME` redirects straight to `APP_HOME_REDIRECT`. If the User also
    // lacks privileges for that route, sending them back to `APP_HOME` would
    // bounce them into an infinite redirect loop. Send them to the first
    // route in the main navigation they do have privileges for instead, so
    // they still land inside the app with the main menu visible. This is
    // just the default-landing fallback rather than a blocked access
    // attempt, so we skip the "not authorized" toast below.
    if (ctx.to.name === CONFIG_ROUTES.APP_HOME_REDIRECT) {
      const fallbackRouteName = getFirstAccessibleNavigationRouteName(auth.user.privileges);
      return { name: fallbackRouteName ?? 'shadow-zone' };
    }

    useNotifyStore().error(AUTH_MESSAGE_NOT_AUTHORIZED);
    console.warn('User lacks required privileges for route.', { route: ctx.to.name, privileges });
    return { name: CONFIG_ROUTES.APP_HOME };
  }
};

export default UserHasPrivileges;
